module.exports = __webpack_public_path__ + "media/dilpreet_testimonial.599d14f9.mp4";